import React, { useEffect, useState } from "react";
import personlTraningICon from "../../Assests/personlTraningICon.png";
import { Pencil } from "lucide-react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  get_price_data,
  query_marriagee_save,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import { CustomAlert } from "../../CommonJquery/CustomAlert";
import { retrieveData } from "../../LocalConnection/LocalConnection";
export default function FinalPayment({ FinalDataPass, Page_Name }) {
  const [Price, setPrice] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [AskLimit, setAskLimit] = useState(0);
  const [dobTime, setDobTime] = useState("");
  const [dobTime1, setDobTime1] = useState("");
  const [selectedCommunication, setSelectedCommunication] = useState("phone");
  const [dobDay, setDobDay] = useState("");
  const [dobMonth, setDobMonth] = useState("");
  const [dobYear, setDobYear] = useState("");
  const [CustomerName, setCustomerName] = useState("");
  const [CustomerEmail, setCustomerEmail] = useState("");
  const [CustomerMobileNo, setCustomerMobileNo] = useState("");
  const [email, setEmail] = useState("example@email.com"); // Default email address
  const [inputValue, setInputValue] = useState("");
  const master_data_get_data = async () => {
    const fd = new FormData();
    fd.append("page_name", Page_Name);
    setIsLoading(true);
    await server_post_data(get_price_data, fd)
      .then((Response) => {
        const data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          const parsedData = JSON.parse(data[1])["page_data"];
          setPrice(parsedData[0].payment_amount);
          setAskLimit(parsedData[0].total_ask);
        }
        // ✅ Retrieve customer data
        const customer_name_data = retrieveData("customer_name");
        const customer_email_data = retrieveData("customer_email");
        const customer_mobile_no_data = retrieveData("customer_mobile_no");

        setCustomerName(customer_name_data);
        setCustomerEmail(customer_email_data);
        setCustomerMobileNo(customer_mobile_no_data);
        setPhoneNumber(customer_mobile_no_data);
        setEmail(customer_email_data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    master_data_get_data();
  }, []);

  const timeSlots = [
    "10:00 AM - 12:00 PM",
    "12:00 PM - 2:00 PM",
    "2:00 PM - 4:00 PM",
    "4:00 PM - 6:00 PM",
    "6:00 PM - 8:00 PM",
    "8:00 PM - 10:00 PM",
  ];
  const timeSlots_for_select = [
    "10:00:00-12:00:00",
    "12:00:00-14:00:00",
    "14:00:00-16:00:00",
    "16:00:00-18:00:00",
    "18:00:00-20:00:00",
    "20:00:00-22:00:00",
  ];
  const handleStep2Validation = () => {
    const newErrors = {};
    if (!selectedDate) newErrors.date = "Please select the date.";
    if (!selectedSlot) newErrors.slot = "Please select the slot.";

    setStep2Errors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      master_data_save();
    }
  };
  const [isEditingNumber, setIsEditingNumber] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("+91 8223055792");
  const [selectedDate, setSelectedDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [step2Errors, setStep2Errors] = useState({
    date: "",
    slot: "",
  });

  const handleSelectSlot = (item, index) => {
    let data = timeSlots_for_select[index].split("-");

    setDobTime(data[0]);
    setDobTime1(data[1]);
    setSelectedSlot(item);
  };

  const handleCommunicationSelect = (method) => {
    setSelectedCommunication(method);
    setInputValue(method === "email" ? email : phoneNumber); // Pre-fill input based on selection
  };
  let mode_of_call_id = "";
  const master_data_save = async () => {
    let msg = "";
    mode_of_call_id = "";

    if (selectedCommunication == "phone") {
      mode_of_call_id = phoneNumber;
    } else if (selectedCommunication == "Private") {
      mode_of_call_id = phoneNumber;
    } else if (selectedCommunication == "video") {
      mode_of_call_id = phoneNumber;
    }

    // Validation
    if (!dobYear || !dobMonth || !dobDay) {
      msg = "Please enter your date of call";
    } else if (!dobTime || !dobTime1) {
      msg = "Please enter your time of call";
    } else if (mode_of_call_id == "") {
      msg = "Please enter your Vaild data For Call";
    }
    if (msg === "") {
      setIsLoading(true);
      const fd = FinalDataPass;
      fd.append("mode_of_call", selectedCommunication);
      fd.append("for_call_date", dobYear + "-" + dobMonth + "-" + dobDay);
      fd.append("for_call_time", dobTime);
      fd.append("to_call_time", dobTime1);
      fd.append("mode_of_call_id", mode_of_call_id);

      await server_post_data(query_marriagee_save, fd)
        .then(async (Response) => {
          setIsLoading(false);

          let data = Response.other_data.split("~@~");

          if (parseInt(data[0]) === 1) {
            CustomAlert("Error", data[1]);
          } else {
            let rawPayloadString = Response.phone_data; // already stringified JSON

            // ✅ Parse & clean payload (in case it's double-escaped)
            let payloadObject = JSON.parse(rawPayloadString); // clean, properly encoded JSON
            if (payloadObject.payUrl != "") {
              window.location.href = payloadObject.payUrl;
            }
          }
        })
        .catch((error) => {
          console.log("API Error:", error);
          setIsLoading(false);
        });
    } else {
      CustomAlert("Error", msg);
    }
  };

  return (
    <>
      <div className="space-y-6 text-center text-purple-100">
        <h2 className="text-xl font-bold">
          Select your Preferred Mode of Communication
        </h2>
        <div className="flex justify-center gap-4 flex-wrap">
          <button
            onClick={() => handleCommunicationSelect("Private")}
            className={`px-5 py-2 rounded-full font-medium text-sm transition border ${
              selectedCommunication === "Private"
                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
                : "bg-slate-700/50 text-purple-300 border-[var(--primary-border)] hover:bg-gradient-to-r from-purple-500 to-pink-500"
            }`}
          >
            Private Chat
          </button>
          <button
            onClick={() => handleCommunicationSelect("Private")}
            className={`px-5 py-2 rounded-full font-medium text-sm transition border ${
              selectedCommunication === "Private"
                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
                : "bg-slate-700/50 text-purple-300 border-[var(--primary-border)] hover:bg-gradient-to-r from-purple-500 to-pink-500"
            }`}
          >
            Private Chat
          </button>
          <button
            onClick={() => handleCommunicationSelect("phone")}
            className={`px-5 py-2 rounded-full font-medium text-sm transition border ${
              selectedCommunication === "phone"
                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
                : "bg-slate-700/50 text-purple-300 border-[var(--primary-border)] hover:bg-gradient-to-r from-purple-500 to-pink-500"
            }`}
          >
            Phone Call
          </button>
          <button
            onClick={() => handleCommunicationSelect("video")}
            className={`px-5 py-2 rounded-full font-medium text-sm transition border ${
              selectedCommunication === "video"
                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
                : "bg-slate-700/50 text-purple-300 border-[var(--primary-border)] hover:bg-gradient-to-r from-purple-500 to-pink-500"
            }`}
          >
            Video Call
          </button>
        </div>

        <div className="text-sm text-purple-200">
          Is this the correct number for {selectedCommunication}?{" "}
          {isEditingNumber ? (
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="bg-slate-700 px-2 py-1 rounded ml-2 text-white"
            />
          ) : (
            <span className="text-pink-400 font-medium ml-2">
              {phoneNumber}
            </span>
          )}
          {isEditingNumber ? (
            <button
              onClick={() => setIsEditingNumber(false)}
              className="ml-2 bg-green-600 text-white px-2 py-1 rounded text-xs"
            >
              Save
            </button>
          ) : (
            <button
              onClick={() => setIsEditingNumber(true)}
              className="ml-2 text-yellow-400"
            >
              <Pencil size={16} />
            </button>
          )}
        </div>
        <div className="w-full max-w-xs mx-auto cusm_date_picker_container">

          <label className="block text-sm font-medium text-purple-200 mb-1">
            Select Date
          </label>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format="DD/MM/YYYY"
              value={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);

                if (date) {
                  setDobDay(date.date().toString().padStart(2, "0"));
                  setDobMonth((date.month() + 1).toString().padStart(2, "0")); 
                  setDobYear(date.year().toString());
                  setShowDatePicker(false);
                  setStep2Errors({ ...step2Errors, date: "" });
                }
              }}
          
              slotProps={{
                textField: {
                  fullWidth: true,
                  placeholder: "Select your birth date",
                  variant: "outlined",
                  className:
                    "custom-datepicker bg-slate-800 text-purple-100 rounded-md",
                },
              }}
            />
          </LocalizationProvider>
          {step2Errors.date && (
            <span className="text-sm text-red-400 mt-2 block">
              Please select the date.
            </span>
          )}
        </div>

        <div className="flex flex-col items-center space-y-4">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-4 mb-3">
            {timeSlots.map((slot, index) => (
              <button
                key={index}
                onClick={() => {
                  handleSelectSlot(slot, index);
                }}
                className={`px-5 py-2 rounded-md border border-[var(--light-pink-color)] transition-all duration-200
            ${
              selectedSlot === slot
                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
                : "bg-slate-700/50 text-purple-300 hover:bg-gradient-to-r from-purple-500 to-pink-500 hover:text-[var(--white)]"
            }`}
              >
                {slot}
              </button>
            ))}
            {step2Errors.slot && (
              <span className="text-sm text-red-400 text-center block mt-1">
                Please select the slot.
              </span>
            )}
          </div>
        </div>
        <hr />
        <div className="text-purple-300 pt-2">
          <p className="font-medium">
            Payment - ₹{Price}{" "}
            <span className="text-sm">
              for consultation ({AskLimit} question)
            </span>
          </p>
          <img
            src={personlTraningICon}
            alt="img"
            className="mt-4 mb-3 mx-auto max-h-[230px] max-w-[230px]"
          ></img>
          <div className="pt-4 space-y-4">
            <button
              type="button"
              onClick={handleStep2Validation}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary hover:bg-primary/90 h-10 px-4 py-4 w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-[var(--white)] font-semibold rounded-full"
            >
              Make A Payment
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
